
const transformReceiptForDownload = (data) => {
    let transformedRows = [];
    
    data.forEach(bill => {
        
        // Handle payments array
        bill.payments.forEach(payment => {
            transformedRows.push({
                bill_id: bill.bill_id,
                date_bill: bill.date_bill,
                waiter: bill.waiter_name,
                table: bill.table,
                room: bill.room,
                total_sale: bill.total_sale,
                type: 'payment',
                payment_code: payment.code,  // Using 'code' as the identifier for the payment type
                payment_amount: payment.amount,
            });
        });
    });

    return transformedRows;
};

export {
   transformReceiptForDownload
};